import { makeResetStyles, mergeClasses } from '@fluentui/react-components';
import type { AnimatedPlaceholderSlots, AnimatedPlaceholderState } from './AnimatedPlaceholder.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const animatedPlaceholderClassNames: SlotClassNames<Omit<AnimatedPlaceholderSlots, 'motion'>> = {
  root: 'fai-AnimatedPlaceholder',
  placeholder: 'fai-AnimatedPlaceholder__placeholder',
};

/**
 * Styles for the root slot
 */
const useRootClassNames = makeResetStyles({
  overflow: 'clip',
});

/**
 * Apply styling to the AnimatedPlaceholder slots based on the state
 */
export const useAnimatedPlaceholderStyles_unstable = (state: AnimatedPlaceholderState): AnimatedPlaceholderState => {
  'use no memo';

  const rootClassNames = useRootClassNames();
  state.root.className = mergeClasses(animatedPlaceholderClassNames.root, rootClassNames, state.root.className);

  if (state.placeholder) {
    state.placeholder.className = mergeClasses(animatedPlaceholderClassNames.placeholder, state.placeholder.className);
  }

  return state;
};
